// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prev-blog-post{text-decoration:none;color:#000!important}.prev-blog-post:hover{color:#5c94fc!important}.next-blog-post{text-decoration:none;color:#000!important}.next-blog-post:hover{color:#5c94fc!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
